var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleasenoteblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.916665 52.916666",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#919191;",
    fillOpacity: 1,
    d: "m 21.75281,2.0933767 c -0.202866,0 -0.397379,0.080033 -0.540778,0.2226868 L 6.7852513,16.648671 c -0.1433985,0.142665 -0.2239485,0.335913 -0.2237498,0.537658 v 29.861057 c 0,2.118026 1.739678,3.846399 3.8711665,3.846399 h 30.10875 c 2.131291,0 3.870966,-1.728373 3.870966,-3.846399 V 5.9399743 c 0,-2.1180296 -1.739675,-3.8465976 -3.870966,-3.8465976 z m 0.317028,1.520104 h 18.47158 c 1.31008,0 2.341117,1.0243355 2.341117,2.3264936 V 47.047386 c 0,1.302156 -1.031037,2.326491 -2.341117,2.326491 h -30.10875 c -1.3104762,0 -2.3413159,-1.024335 -2.3413159,-2.326491 V 17.500901 L 22.069838,3.6134807",
    id: "path1",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#919191;",
    fillOpacity: 1,
    d: "M 18.699075,17.946085 H 6.5613028 L 22.517735,2.0933767 V 14.152246 c 0,2.095306 -1.709645,3.793839 -3.81866,3.793839",
    id: "path2",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 14.15646,22.419255 c -0.536004,0 -0.970179,0.431549 -0.970377,0.963675 v 1.395619 c 2.11e-4,0.532125 0.434373,0.963674 0.970377,0.963674 h 22.66097 c 0.535604,0 0.970376,-0.431549 0.970376,-0.963674 V 23.38293 c 0,-0.532126 -0.434772,-0.963675 -0.970376,-0.963675 H 14.15646",
    id: "path3",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 14.15646,23.38293 h 22.66097 v 1.395223 H 14.15646 V 23.38293",
    id: "path4",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 14.15646,30.214998 c -0.536004,4.02e-4 -0.970179,0.431945 -0.970377,0.96407 v 1.395025 c 2.11e-4,0.532716 0.434373,0.964268 0.970377,0.964268 h 22.66097 c 0.535604,0 0.970376,-0.431552 0.970376,-0.964268 v -1.395025 c 0,-0.532125 -0.434772,-0.963675 -0.970376,-0.96407 H 14.15646",
    id: "path5",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 14.15646,31.179068 h 22.66097 v 1.395025 H 14.15646 v -1.395025",
    id: "path6",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 14.15646,38.011532 c -0.536004,0 -0.970179,0.43135 -0.970377,0.963676 v 1.395616 c 2.11e-4,0.532123 0.434373,0.963477 0.970377,0.963477 h 22.66097 c 0.535604,0 0.970376,-0.431354 0.970376,-0.963477 v -1.395616 c 0,-0.532326 -0.434772,-0.963676 -0.970376,-0.963676 H 14.15646",
    id: "path7",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 14.15646,38.975208 h 22.66097 v 1.395023 H 14.15646 v -1.395023",
    id: "path8",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#1a1a1a",
    fillOpacity: 1,
    d: "m 30.44583,7.8485512 h 4.519747 c 1.56366,0 2.822229,1.2503864 2.822229,2.8032888 v 4.490362 c 0,1.553497 -1.258569,2.803883 -2.822229,2.803883 H 30.44583 c -1.563659,0 -2.822229,-1.250386 -2.822229,-2.803883 V 10.65184 c 0,-1.5529024 1.25857,-2.8032888 2.822229,-2.8032888",
    id: "path9",
    style: {
      strokeWidth: 0.0507496,
      fill: "#2f92d0",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleasenoteblue);
export default __webpack_public_path__ + "static/media/releasenoteblue.e3cf7eaf431753700f902d6824eea0d3.svg";
export { ForwardRef as ReactComponent };